'use strict';
import actionTypes from '../actionTypes';

const initialState = {
    items: [],
    totalRecords: 0,
    pageSize: 20,
    pageNumber: 1,
    sort: null
};

function wishlistReducer(state = initialState, action) {
    switch (action.type) {
        case actionTypes.GO_TO_PAGE: {
            return {
                ...state,
                items: action.items.Records,
                pageSize: action.items.PageSize,
                totalRecords: action.items.TotalRecords,
                pageNumber: action.items.PageNumber
            };
        }
        case actionTypes.SORT_WISHLIST_RESULT: {
            return {
                ...state,
                items: action.items.Records,
                sort: action.sort
            };
        }
        default:
            return state;
    }
}

export { wishlistReducer };

export default {
    wishlistReducer: wishlistReducer
};
